// 移动端路由配置
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const mobileRoutes = [
  {
    path: '/',
    name: 'MobileHome',
    component: () => import('../views/mobile/MobileHome.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/news/:id',
    name: 'MobileNewsDetail',
    component: () => import('../views/mobile/MobileNewsDetail.vue'),
    meta: { title: '新闻详情' }
  },
  {
    path: '/cases',
    name: 'MobileCases',
    component: () => import('../views/mobile/MobileCases.vue'),
    meta: { title: '项目案例' }
  },
  {
    path: '/cases/:id',
    name: 'MobileCaseDetail',
    component: () => import('../views/mobile/MobileCaseDetail.vue'),
    meta: { title: '案例详情' }
  },
  {
    path: '/partners',
    name: 'MobilePartners',
    component: () => import('../views/mobile/MobilePartners.vue'),
    meta: { title: '合作伙伴' }
  },
  {
    path: '/partner-detail',
    name: 'MobilePartnerDetail',
    component: () => import('../views/mobile/MobilePartnerDetail.vue'),
    meta: { title: '合作伙伴详情' }
  },
  {
    path: '/about',
    name: 'MobileAbout',
    component: () => import('../views/mobile/MobileAbout.vue'),
    meta: { title: '关于我们' }
  },
  {
    path: '/services',
    name: 'MobileServices',
    component: () => import('../views/mobile/MobileServices.vue'),
    meta: { title: '业务范围' }
  },
  {
    path: '/contact',
    name: 'MobileContact',
    component: () => import('../views/mobile/MobileContact.vue'),
    meta: { title: '联系我们' }
  }
]

export default mobileRoutes